import { render } from '@react-email/render';
import { Port } from '../../maritime-menu-options/world-ports-panel/world-ports.model';
import {
  getProVesselTypeLabel,
  ProReportResponse,
  ProVesselTypes,
} from '../../models/pro.model';
import ProReportEmail from './pro-report-email-export';

async function getProReportEmailContent(
  currentPort: Port,
  currentReport: ProReportResponse,
  selectedVesselType: ProVesselTypes
) {
  const email = <ProReportEmail port={currentPort} report={currentReport} />;
  const htmlBody = await render(email);
  const textBody = await render(email, { plainText: true });
  const subject = `GlobeView Pro Report - ${currentPort.NAME}, ${
    currentPort.COUNTRY
  }, (UNLOCODE: ${currentPort.UNLOCODE}), ${getProVesselTypeLabel(
    selectedVesselType
  )}`;
  return { subject, htmlBody, textBody };
}

export default getProReportEmailContent;
